import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import AppDownloadAuthContainer from './app_download_auth_container.component';
import { ServicesNameType } from '../../dto/appdescriptions.dto';
import { WebchatAuthService } from '../../services/webchatauth.service';
import {AppServices} from "./consts";

type Props = {
    name: ServicesNameType;
};

const AppDownloadAuthPage: React.FC<Props> = ({ name }) => {
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('loading');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        const search = typeof window !== 'undefined' ? window.location.search : '';
        const params = new URLSearchParams(search);

        if (params.get('success') === 'true') {
            setStatus('success');
            return;
        }

        const code = params.get('code');
        const state = params.get('state');

        if (!code || !state) {
            window.location.replace('/only_assist');
            return;
        }

        setStatus('loading');
        const redirectUri = window.location.origin + window.location.pathname;
        const service = AppServices[name] || '';
        new WebchatAuthService()
            .auth(code, state, redirectUri, service)
            .then((e) => {
                if (!e || (e && !e.success)) {
                    let error = '';
                    if (e && e.error) {
                        if (typeof e.error === 'string') {
                            error = e.error;
                        } else if (e.error.messages && Array.isArray(e.error.messages)) {
                            error = e.error.messages.join(', ');
                        } else {
                            error = JSON.stringify(e.error);
                        }
                    }
                    setErrorMessage(error);
                    setStatus('error');
                } else {
                    window.location.replace('/only_assist/auth?success=true');
                    setStatus('success');
                }
            })
            .catch((e) => {
                const error = typeof e === 'string' ? e : e.status;
                setErrorMessage(error);
                setStatus('error');
            });
    }, []);

    if (status === 'loading') {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
                <Spinner animation="grow" />
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div style={{ padding: '1rem' }}>
                <h3>Ошибка</h3>
                <p>{errorMessage}</p>
            </div>
        );
    }

    return <AppDownloadAuthContainer name={name} />;
};

export default AppDownloadAuthPage;
